/**
 * Status and progress bar UI management.
 * @module ui/status
 */

/**
 * Updates the status message displayed to the user.
 * @param {string} msg - Status message text
 * @param {string} cssClass - CSS class ("status-ok", "status-err", or "status-inf")
 */
export function setStatus(msg, cssClass) {
  const el = document.getElementById("status");
  el.textContent = msg;
  el.className   = cssClass;
}

/** Progress bar management. */
export const progress = {
  /** Shows the progress container. */
  show() { document.getElementById("progress-container").style.display = "block"; },
  /** Hides the progress container. */
  hide() { document.getElementById("progress-container").style.display = "none"; },
  /**
   * Updates the progress label and bar width.
   * @param {string} label - Step name
   * @param {number} current - Current step
   * @param {number} total - Total steps
   */
  update(label, current, total) {
    document.getElementById("progress-label").textContent = `${label} (${current}/${total})`;
    document.getElementById("progress-bar").style.width = `${Math.round((current / total) * 100)}%`;
  },
};
